<template>
  <button class="cursor-pointer text-slate-white my-1 pb-1" @click.prevent="logout()">{{ t('logout') }}</button>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { useRouter } from 'vue-router'

  import { Parcel } from '@/common/classes'
  import { ParcelType } from '@/constants'

  import useWallStore from '@/composables/wallStore'
  import { useUserStore } from '@/composables/userStore'
  import { useNoteStore } from '@/composables/noteStore'

  import useParcelStore from '@/composables/parcel'

  const userStore = useUserStore()
  const wallStore = useWallStore()
  const noteStore = useNoteStore()
  const parcelStore = useParcelStore()
  const router = useRouter()

  const { t } = useI18n()

  async function parcelLogoutFromTalkWall() {
    const user = userStore.getters.user.value
    if (user) {
      const parcel = new Parcel({ parcelType: ParcelType.UserLogout }, user, wallStore.getters.selectedWall.value)
      await parcelStore.actions.sendParcel(user._id, parcel)
      await parcelStore.actions.unSubscribeTopic(user._id)
      for (const group of user.profile.groups) {
        await parcelStore.actions.unSubscribeTopic(group.originalId)
      }
    }
    await parcelStore.actions.closeMQTTConnection()
  }

  async function logout() {
    wallStore.actions.reset()
    noteStore.actions.clearNotes()
    await parcelLogoutFromTalkWall()
    userStore.actions.logout()
  }
</script>

<style scoped></style>
